import React, { useState, useMemo } from 'react'
import Link from 'next/link'
import { useRouter } from 'next/router'

import { Pagination, Text, Column, ProgressBar, Badge, GlobalFilter, Option } from 'components'
import {
  Content,
  Main,
  Detail,
  ContainerCard,
  Image,
  CardInfo,
  Label,
  FilterContainer,
  Warranty,
  OptionClose
} from './styles'

import { calculatePercent, formatCurrency, remainingDays, getOldStatus, formatTax } from 'helpers'
import { campaignStatuses, campaignTypes } from 'constants'

import PropTypes from 'prop-types'

const Card = ({
  campaing,
  hasPaginationTop,
  hasPaginationBottom,
  offset,
  rowCount,
  navigationTo,
  openFilter,
  children,
  filterValue,
  handleFilterCleaning
}) => {
  const router = useRouter()
  const [filter, setFilter] = useState('')

  const data = useMemo(
    () => campaing.filter(campaing => campaing.name.toUpperCase().indexOf(filter.toUpperCase()) != -1 && campaing),
    [campaing, filter]
  )

  const paginationcampaing = useMemo(() => {
    let list = [[]]
    let group = 0

    for (let i = 0; i < data.length; i++) {
      list[group].push(data[i])

      if (list[group].length === rowCount) {
        group++

        if (i + 1 < data.length) {
          list[group] = []
        }
      }
    }

    return list
  }, [data, rowCount])

  const getStatusCampaing = (status, isBefore, isAvailable) => {
    if (isBefore) {
      return <Badge color='yellow' status={'Em Breve'} campaing={true} before={true} />
    } else {
      if (!isAvailable) {
        return <Badge color='green' status={'Concluída'} campaing={true} />
      } else {
        switch (getOldStatus(status)) {
          case campaignStatuses.CLOSED:
          case campaignStatuses.CLOSED_WITHOUT_CAPTATION:
            return <Badge color='green' status={'Concluída'} campaing={true} />
            break
          case campaignStatuses.ACTIVE:
            return <Badge color='blue' status={'Em captação'} campaing={true} />
            break
          case campaignStatuses.WAITING_LIST:
            return <Badge color='yellow' status={'Lista de espera'} campaing={true} />
            break
          default:
            return <Badge color='blue' status={'Em captação'} campaing={true} />
            break
        }
      }
    }
  }

  return (
    <Main>
      <FilterContainer>
        <GlobalFilter
          filter={filter}
          setFilter={value => {
            navigationTo(0)
            setFilter(value)
          }}
        />
        <div>
          <Option name='Filtrar' imgUrl='/img/filter.svg' title='Filtrar' onPress={openFilter} />
          {filterValue.all !== true || rowCount !== 12 ? (
            <OptionClose name='Limpar Filtro' imgUrl='/img/closeFilter.svg' onPress={handleFilterCleaning} />
          ) : (
            ''
          )}
        </div>
      </FilterContainer>

      {children}

      {hasPaginationTop && rowCount > 1 && campaing.length > 15 && (
        <Pagination
          pagination={{
            offset,
            rowCount,
            limit: 1,
            pageCount: paginationcampaing.length
          }}
          search={({ page }) => navigationTo(page - 1)}
        />
      )}

      <Content>
        {paginationcampaing[offset] &&
          paginationcampaing[offset].map((campaing, index) => {
            return (
              <Link
                key={index}
                href={`/campanhas/${campaing.campaign_type_id === 1 ? 'com-aval' : 'com-aval-e-garantia'}/${
                  campaing.url
                }`}
              >
                <a style={{ margin: '0px 12px 24px 12px', textDecoration: 'none' }}>
                  <ContainerCard
                    color={index}
                    onClick={() =>
                      router.push(
                        `/campanhas/${campaing.campaign_type_id === 1 ? 'com-aval' : 'com-aval-e-garantia'}/${
                          campaing.url
                        }`
                      )
                    }
                  >
                    <div style={{ gridArea: 'image' }}>
                      {!!campaing.brand_image ? (
                        <Image backgroundImage={campaing.brand_image.photo_url} alt='image'>
                          {getStatusCampaing(
                            campaing.campaign_status.abbreviation,
                            campaing.is_before_start_date,
                            campaing.is_available_for_investments
                          )}
                          {campaing.campaign_type_id === campaignTypes.AVAL_E_GARANTIA && campaing.collateral > 0 && (
                            <Warranty>
                              <img src='/img/selo-garantias-escudo.svg' />
                              {`${campaing.collateral}% de garantia em ${campaing.warranty || 'aplicação financeira'}`}
                            </Warranty>
                          )}
                        </Image>
                      ) : (
                        getStatusCampaing(
                          campaing.campaign_status.abbreviation,
                          campaing.is_before_start_date,
                          campaing.is_available_for_investments
                        )
                      )}
                    </div>
                    <div style={{ gridArea: 'name', padding: '16px', position: 'relative', top: '-15px' }}>
                      <Text variant='subtitle2'>{campaing.name}</Text>
                    </div>
                    <CardInfo>
                      <Column style={{ gridArea: 'month', position: 'relative', top: '-49px' }}>
                        <Label>Taxa mensal</Label>
                        <Text variant='subtitle1'>{formatTax(campaing.rate_month)}</Text>
                      </Column>
                      <Column style={{ gridArea: 'anual', position: 'relative', top: '-49px' }}>
                        <Label>Taxa anual</Label>
                        <Text variant='subtitle1'>{formatTax(campaing.rate_anual)}</Text>
                      </Column>
                      <Column style={{ gridArea: 'deadlines', position: 'relative', top: '-49px' }}>
                        <Label>Prazo</Label>
                        <Text variant='subtitle1'>{campaing.installments} Meses</Text>
                      </Column>
                      <Column style={{ gridArea: 'deadlines', position: 'relative', top: '-49px' }}>
                        <Label>Prazo</Label>
                        <Text variant='subtitle1'>{campaing.installments} Meses</Text>
                      </Column>
                      <Column style={{ gridArea: 'day', position: 'relative', top: '-49px' }}>
                        <Label>Dias restantes</Label>
                        <Text variant='subtitle1'>{remainingDays(campaing.end_date)}</Text>
                      </Column>
                      <Column style={{ gridArea: 'captured', position: 'relative', top: '-49px' }}>
                        <Label>Captado</Label>
                        <Text variant='subtitle2'>
                          {formatCurrency(
                            getOldStatus(campaing.campaign_status.abbreviation) === campaignStatuses.CLOSED ||
                              getOldStatus(campaing.campaign_status.abbreviation) === campaignStatuses.WAITING_LIST
                              ? campaing.amount
                              : campaing.total_captured > campaing.amount
                              ? campaing.amount
                              : campaing.total_captured
                          )}
                        </Text>
                      </Column>
                      <Column style={{ gridArea: 'goal', position: 'relative', top: '-49px' }}>
                        <Label>Meta</Label>
                        <Text variant='subtitle2'>{formatCurrency(campaing.amount)}</Text>
                      </Column>
                      <Column style={{ gridArea: 'bar', position: 'relative', top: '-40px' }}>
                        <ProgressBar
                          title={`${
                            getOldStatus(campaing.campaign_status.abbreviation) === campaignStatuses.CLOSED ||
                            getOldStatus(campaing.campaign_status.abbreviation) === campaignStatuses.WAITING_LIST
                              ? calculatePercent(campaing.amount, campaing.amount)
                              : calculatePercent(campaing.amount, campaing.total_captured)
                          }%`}
                          initialValue={campaing.total_captured}
                          finalValue={campaing.amount}
                          value={Number(
                            getOldStatus(campaing.campaign_status.abbreviation) === campaignStatuses.CLOSED ||
                              getOldStatus(campaing.campaign_status.abbreviation) === campaignStatuses.WAITING_LIST
                              ? calculatePercent(campaing.amount, campaing.amount)
                              : calculatePercent(campaing.amount, campaing.total_captured)
                          )}
                          desativeValue
                          percentage
                        />
                      </Column>
                      <Column
                        style={{
                          gridArea: 'detail',
                          display: 'flex',
                          alignItems: 'center',
                          position: 'relative',
                          top: '-24px'
                        }}
                      >
                        <Link
                          href={`/campanhas/${campaing.campaign_type_id === 1 ? 'com-aval' : 'com-aval-e-garantia'}/${
                            campaing.url
                          }`}
                        >
                          <Detail title='Ver detalhes'>Ver detalhes</Detail>
                        </Link>
                      </Column>
                    </CardInfo>
                  </ContainerCard>
                </a>
              </Link>
            )
          })}
      </Content>

      {hasPaginationBottom && rowCount > 1 && campaing.length > 15 && (
        <Pagination
          pagination={{
            offset,
            rowCount,
            limit: 1,
            pageCount: paginationcampaing.length
          }}
          search={({ page }) => navigationTo(page - 1)}
        />
      )}
    </Main>
  )
}

Card.propTypes = {
  campaing: PropTypes.array,
  hasPaginationTop: PropTypes.bool,
  hasPaginationBottom: PropTypes.bool,
  offset: PropTypes.number,
  rowCount: PropTypes.number,
  pageCount: PropTypes.number,
  navigationTo: PropTypes.func
}

export default Card
